$ = jQuery

module.exports = class Value

  duration: 200

  constructor: (el) ->
    @$el = $(el)
    @$buttonEl = @$el.find '.value__button'
    @$contentEl = @$el.find '.value__content'

  hide: (cb = ->) ->
    @$contentEl.velocity 'fadeOut', duration: @duration, complete: =>
      @$buttonEl.velocity {'margin-bottom': "0px"}, duration: @duration, complete: =>
        @$el.removeClass 'active'
        cb()

  show: (cb = ->) ->
    space = @$contentEl.innerHeight()
    @$buttonEl.velocity {'margin-bottom': "#{space}px"}, duration: @duration, complete: =>
      @$contentEl.css 'margin-top', "#{-space}px"
      @$contentEl.velocity 'fadeIn', duration: @duration
      @$el.addClass 'active'
      cb()
